import React, {Fragment} from "react";
import "./StencilQuotationImageUploader.css";
import {FormattedMessage} from "react-intl";
import StencilQuotationImage from "../StencilQuotationImage/StencilQuotationImage";
import FileUploaderProgress from "../../FileUploadingProgressImage/FileUploadingProgressImage";
import {IS_IN_MOBILE_MODE} from "../../../../../configuration";

const uploaderStyle = {
    display: 'none'
};

const gerberImageData = {
    fileUrl: "",
    id: -1,
    imageUrl: "",
    imageUrlBottom: "",
    imageUrlTop: "",
    key: "",
    originalFileName: ""

};


const StencilQuotationImageUploader = (props) => {
    return (
        <Fragment>
            <div className="row gerber-upload-div" style={props.gerberDivStyle}>
                <div className="upload-image-msg stb-pcb-select-responsive">
                    <span> <FormattedMessage id="app.pcb-quotation.pcb-add-gerber-file-caption"
                                             defaultMessage="Please select a gerber file and upload it"
                                             description=""
                    />
                    </span>
                </div>
                <div className="gerber-upload-button">
                    <button className="btn file-upload-button"
                            onClick={props.launchStencilFileUploader}>
                        <span className="upload-btn-msg">
                            <FormattedMessage id="app.stencil-quotation.pcb-add-gerber-file-msg"
                                              defaultMessage="Extended Gerber data (RS-274X)"
                                              description=""
                            />
                        </span>
                        <br/>
                        {props.fileName !== "" ? props.fileName :
                            <FormattedMessage id="app.stencil-quotation.stencil-add-gerber-file"
                                              defaultMessage="Add your gerber file"
                                              description=""
                            />}
                        <input type="file" id="stencil_uploader" accept="application/zip,application.rar"
                               style={uploaderStyle}
                               onChange={props.stencilFileUploaderClicked}/>

                    </button>
                    <br/><br/>
                    <small className="gerber-message">
                        &#x1360; <FormattedMessage id="app.stencil-quotation.stencil-gerber-button-caption"
                                                   defaultMessage="Only accept zip or rar, Max 4M"
                                                   description=""
                    />
                    </small>
                    <br/>
                    <small className="gerber-message-2">
                        &#x1360; <FormattedMessage id="app.pcb-quotation.pcb-gerber-button-caption-3"
                                                   defaultMessage="Uploaded Gerber data. Please wait for a while until the automatic check is completed."
                                                   description=""/>
                    </small><br hidden={!IS_IN_MOBILE_MODE}/>
                    <small className="gerber-message-2">しばらくお待ちください。<br/></small>
                    <br/>
                    <br/>
                    {/*<small className="gerber-message-2 msg-content-3">*/}
                    {/*    &#x1360; アップロードが出来ない場合は、<span className="uploader-text-cursor" onClick={()=>{document.getElementById("sub-title-span-resp").click()}}>こちらから</span>お問合せ下さい。*/}
                    {/*</small>*/}
                    {props.imageData.id !== gerberImageData.id ?
                        <div>
                            <small className="gerber-message-2 msg-content-3"><span className="glyphicon glyphicon-ok-sign green"></span> アップロードの処理が終了しました。<br/></small>
                            <small className="gerber-message-2 msg-content-3"> 下記のメタルマスク仕様を入力し、カートに保存して下さい<br/></small>
                            <small className="gerber-message-2 msg-content-3 gerber-message-margin"> ※ガーバービュアーが表示されないお客様へ（ビュアー率75％）<br/></small>
                        </div> : ''
                    }
                </div>
            </div>
            <div className="">
                {props.gerberError ? <div className="text-center text-danger-error"><h5><b>ガーバーアップロードエラー。TOP画面からもう一度お試しください。</b></h5></div> : ''}
                {props.imageData.id !== gerberImageData.id  && props.imageData.layers !== -1 ?
                    <StencilQuotationImage imageData={props.imageData} fileUrl={props.imageData["fileUrl"]} imageUrl={props.imageData["imageUrl"]}/> : ''}
            </div>
            <div className="row">
                {props.isGerberUploading ?
                    <FileUploaderProgress/> : ''}
            </div>
        </Fragment>
    )
};

export default StencilQuotationImageUploader;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/StencilQuotationForm/StencilQuotationImageUploader/StencilQuotationImageUploader.js